import { useState, useEffect } from "react";
import copy from "copy-to-clipboard";

export default function useCopyToClipboard(
  resetInterval?: number
): [
  boolean,
  (
    content: string,
    format: "text/html" | "text/plain",
    fallback?: string
  ) => void
] {
  const [isCopied, setIsCopied] = useState(false);

  function copyToClipboard(
    text: string,
    format: "text/html" | "text/plain",
    fallback?: string
  ) {
    if (text) {
      // Adds a plain-text fallback format so paste targets that don't accept text/html have something.
      copy(text, {
        format,
        onCopy: fallback
          ? (clipboardData: object) =>
              (clipboardData as DataTransfer).setData("text/plain", fallback)
          : undefined,
      });
      setIsCopied(true);
    } else {
      console.log("No Input Received");
      setIsCopied(false);
    }
  }

  useEffect(() => {
    let timeout: any;
    if (isCopied && resetInterval) {
      timeout = setTimeout(() => setIsCopied(false), resetInterval);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [isCopied, resetInterval]);

  return [isCopied, copyToClipboard];
}
